// src/components/FeatureFlagRoute.jsx
// 🎓 TICKET NVDLP4 - Wrapper para rutas con feature flag
import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * FeatureFlagRoute - Protege rutas detrás de un feature flag
 * 
 * @param {boolean} enabled - Si la feature está habilitada
 * @param {string} fallbackPath - Ruta a la que redirigir si no está habilitada (default: /dashboard)
 * @param {ReactNode} children - Componente a renderizar si está habilitada
 */
const FeatureFlagRoute = ({ enabled, fallbackPath = '/dashboard', children }) => {
  // Si no está habilitado, redirigir al fallback
  if (!enabled) {
    return <Navigate to={fallbackPath} replace />;
  }

  // Si está habilitado, renderizar el contenido
  return <>{children}</>;
};

export default FeatureFlagRoute;
